import React, { useCallback } from 'react';

import classNames from 'classnames';

import { determineBgColor, determineSize } from './utils/styleHelper';

import { Avatar } from '../Avatar';
import { Checkbox } from '../Checkbox';

import type { CheckboxItemType } from './type';

type Props<T> = {
  small?: boolean;
} & CheckboxItemType<T>;

export function CheckboxItem<T>({
  label,
  small,
  value,
  isChecked,
  onChange,
  active,
  selected,
  avatar,
}: Props<T>): React.ReactElement {
  const refinedOnClick = useCallback(() => {
    onChange?.(value);
  }, [onChange, value]);

  return (
    <Checkbox
      className={classNames(
        'mb-0! flex! pl-sm py-sm hover:action-bg-neutral-weak-hover',
        determineBgColor(selected, active),
        determineSize(small),
        {
          'gap-xxs!': avatar,
        },
      )}
      small={small}
      key={`${label}${value}`}
      label={
        <div
          className={classNames('flex -ml-xxs items-center gap-xxs', {
            'text-b3': small,
          })}
        >
          {avatar && <Avatar {...avatar} size={avatar.size || 'sm'} />}
          <span>{label}</span>
        </div>
      }
      onChange={refinedOnClick}
      checked={isChecked || false}
    />
  );
}
